var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DxLoadPanel',{attrs:{"position":_vm.position,"visible":_vm.loadingVisible,"show-indicator":_vm.showIndicator,"show-pane":_vm.showPane,"shading":true,"hide-on-outside-click":_vm.closeOnOutsideClick,"on-shown":_vm.onShown,"shading-color":"rgba(0,0,0,0.4)","message":_vm.loadingMsg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }